import React from 'react'
import styled from '@emotion/styled'
import { useHistory } from 'react-router'
import { SettingsPageLayout } from '../../layout'
import { SETTINGS } from '../../../../config/routes'
import { CreateOrderset, EditOrderset, OrdersetList } from './pages'
import { LoadingModal, LoadingOverlay, useDisclosure } from '@labsavvyapp/components'
import { useOrdersetSettingsPageBusinessLogic } from '../logic/context'

const ComponentLayout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-right: 10px;
  width: 100%;
`

export const OrdersetSettingsPageView: React.FC = () => {
  const { location } = useHistory()

  const pageLogic = useOrdersetSettingsPageBusinessLogic()
  const showLoadingModal = pageLogic?.showLoadingModal ?? false

  const getComponentByRoute = (path: string) => {
    if (path === SETTINGS.orderset) {
      return <OrdersetList />
    } else if (path === SETTINGS.newOrderset) {
      return <CreateOrderset />
    } else if (path.includes(SETTINGS.editOrderset.replace(':ordersetId', ''))) {
      return <EditOrderset />
    }
  }

  return (
    <SettingsPageLayout>
      <ComponentLayout>{getComponentByRoute(location.pathname)}</ComponentLayout>
      <LoadingModal
        loadingMessage="We are saving your changes... please wait"
        successMessage="Your data has been saved"
        errorMessage="Something went wrong. Please try again later."
        opened={showLoadingModal}
        onClose={() => pageLogic?.closeLoadingModal()}
        isLoading={showLoadingModal}
        hasError={false}
      />
    </SettingsPageLayout>
  )
}
